import { render, staticRenderFns } from "./AddModels.vue?vue&type=template&id=585c9829&scoped=true"
import script from "./AddModels.vue?vue&type=script&lang=js"
export * from "./AddModels.vue?vue&type=script&lang=js"
import style0 from "./AddModels.vue?vue&type=style&index=0&id=585c9829&prod&lang=scss"
import style1 from "./AddModels.vue?vue&type=style&index=1&id=585c9829&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585c9829",
  null
  
)

export default component.exports